"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSurveyMetaDataApi = getSurveyMetaDataApi;
exports.surveyConfigurationFetchApi = surveyConfigurationFetchApi;
exports.surveyConfigurationGetApi = surveyConfigurationGetApi;
exports.surveyConfigurationSaveApi = surveyConfigurationSaveApi;
exports.surveyFundListApi = surveyFundListApi;
exports.surveyGoToFundApi = surveyGoToFundApi;
exports.surveyImpactListApi = surveyImpactListApi;
exports.surveyLatestApi = surveyLatestApi;
exports.surveyReadApiForTenant = surveyReadApiForTenant;
exports.surveyRenneringApi = surveyRenneringApi;
exports.surveyTabApi = surveyTabApi;
exports.surveysDetailsApi = surveysDetailsApi;
exports.surveysEmailProviderApi = surveysEmailProviderApi;
exports.surveysExpiryMagicLinkPasswordApi = surveysExpiryMagicLinkPasswordApi;
exports.surveysForgotPasswordApi = surveysForgotPasswordApi;
exports.surveysLoginApi = surveysLoginApi;
exports.surveysPublicDetailsApi = surveysPublicDetailsApi;
var _core = require("../../core/core.service");
var _app = _interopRequireDefault(require("../../../configs/app.config"));
var _tenant = require("../../../constants/endpoints/tenant");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * Login
 * @param payload
 * @returns api response
 * @description this function used to user login by its credencials.
 */
function surveysLoginApi(params) {
  return api.create("".concat(_app.default.baseUrl + _tenant.SurveyService.surveys), params);
}

/**
 * survey details
 * @param payload
 * @returns api response
 * @description this function used to fetch details.
 */
function surveysDetailsApi(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SurveyService.details), params);
}

/**
 * survey details
 * @param payload
 * @returns api response
 * @description this function used to fetch details.
 */
function surveysPublicDetailsApi(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SurveyService.publicDetails), params);
}

/**
 * Forgot Password
 * @param payload
 * @returns api response
 * @description this function used to user forgot password by its credencials.
 */
function surveysForgotPasswordApi(params) {
  var headersConfig = JSON.parse(sessionStorage.getItem("headersConfigForgotPassword"));
  return api.create("".concat(_app.default.baseUrl + _tenant.SurveyService.forgotPassword), params, headersConfig);
}

/**
 * Forgot Password
 * @param payload
 * @returns api response
 * @description this function used to user forgot password by its credencials.
 */
function surveysExpiryMagicLinkPasswordApi(params) {
  return api.create("".concat(_app.default.baseUrl + _tenant.SurveyService.expiryMagicLinkPassword), params);
}

/**
 * survey exists or not
 * @param payload
 * @returns api response
 * @description this function used to check survey exists or not.
 */
function surveysEmailProviderApi(params) {
  return api.update("".concat(_app.default.baseUrl + _tenant.SurveyService.emailProvider), params);
}

// Rendering API

/**
 * survey rendering
 * @param payload
 * @returns api response
 * @description this function used to get survey rendering.
 */
function surveyRenneringApi(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SurveyService.surveyRendering.rendering), params);
}
/**
 * survey rendering
 * @param payload
 * @returns api response
 * @description this function used to get survey rendering.
 */
function surveyLatestApi(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SurveyService.surveyRendering.surveyLatest), params);
}

/**
 * survey tab
 * @param payload
 * @returns api response
 * @description this function used to get survey tab.
 */
function surveyGoToFundApi(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SurveyService.surveyRendering.goToFund), params);
}

/**
 * survey tab
 * @param payload
 * @returns api response
 * @description this function used to get survey tab.
 */
function surveyTabApi(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SurveyService.surveyRendering.tab), params);
}

// survey for tenant read api

/**
 * controller survey read
 * @param payload
 * @returns api response
 * @description this function used to controller survey read.
 */
function surveyReadApiForTenant(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SurveyService.read), params);
}

// Metadata API

/**
 * Login
 * @param payload
 * @returns api response
 * @description this function used to get metadata.
 */
function getSurveyMetaDataApi(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SurveyService.metadata), params);
}

/**
 * survey configuration get
 * @param payload
 * @returns api response
 * @description this function used to fetch survey configuration.
 */
function surveyConfigurationGetApi(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SurveyService.configuration.get), params);
}

/**
 * survey configuration fetch
 * @param payload
 * @returns api response
 * @description this function used to fetch survey configuration.
 */
function surveyConfigurationFetchApi(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SurveyService.configuration.fetch), params);
}

/**
 * survey configuration save
 * @param payload
 * @returns api response
 * @description this function used to save survey configuration.
 */
function surveyConfigurationSaveApi(params) {
  return api.create("".concat(_app.default.baseUrl + _tenant.SurveyService.configuration.save), params);
}

/**
 * survey fund list
 * @param payload
 * @returns api response
 * @description this function used to fetch survey fund list.
 */
function surveyFundListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SurveyService.configuration.fundList), params);
}

/**
 * survey impact list
 * @param payload
 * @returns api response
 * @description this function used to fetch survey impact list.
 */
function surveyImpactListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SurveyService.configuration.impactList), params);
}